export const EXTRA_REWARDS_FILTER = 'extra-rewards';
export const SALE_FILTER = 'sale';

export const EXTRA_REWARDS_FILTER_ID = 1; // Marker, is used in FE filtering
export const SALE_FILTER_ID = 1; // Real value, is used in API request to get products filtered by 'sale'
